// src/environments/environment.staging.ts
export const environment = {
  production: false,
  staging: true,
  appVersion: '1.0.0',
  runtimeConfigUrl: 'assets/config/runtime-config.json',
} as const;
